import React, { Fragment } from 'react';

import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";
import SpinnerDiv from "ui/ReactSpinnerDiv";

const DropdownYearTerms = ({ control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, academic_year, onChange } ) =>
{
    const url = '/year/' + academic_year + '/terms' ;

    const fields = { url: url, keyFieldName: 'year_term_id', labelFieldName: 'description', additionalFields: ['date_from', 'date_to'] }

    const [ loading, items ] = useListboxFetch( fields ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} onChange={onChange} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownYearTerms;
